import { render, staticRenderFns } from "./AddCoordinatorModal.vue?vue&type=template&id=5ae5892f&scoped=true&"
import script from "./AddCoordinatorModal.vue?vue&type=script&lang=js&"
export * from "./AddCoordinatorModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCoordinatorModal.vue?vue&type=style&index=0&id=5ae5892f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae5892f",
  null
  
)

export default component.exports